import React from 'react';

import TextareaAutoresize from 'react-textarea-autosize';

import { useField } from 'formik';

import classNames from 'classnames';

import './index.scss';

const MutateCardAlterTitle = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <TextareaAutoresize
      {...props}
      {...field}
      className={classNames(
        'mutate-card-alter-title',
        { 'mutate-card-alter-title-error': fieldMeta.error },
        // eslint-disable-next-line react/destructuring-assignment
        props.className,
      )}
      placeholder="Alternate title"
    />
  );
};

export default MutateCardAlterTitle;
